import { extend } from 'sk-ui/lib/utils/util.js'

import caseSoftwareForm from './metaData/caseSoftwareForm'

import updateOldToNewProduct from '@/components/UpdateOldToNewProduct'

export default {
  caseSoftwareCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: caseSoftwareForm,
      props
    })
  },
  caseSoftwareEdit({ commit }, params) {
    const props = {
      title: '编辑用例',
      params: {
        id: params.rowIds[0]
      },
      'view.content[$id=testCaseCode].$el': { disabled: true }
    }
    const editForm = extend(true, {}, caseSoftwareForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  batchUpdateSoftwareProduct({ commit }, params) {
    var dialog = params.viewController.$dialog({
      template: h => {
        const caseType = 'SOFTWARE'
        return (
          <sky-update-old-to-new-product
            caseType={caseType}
            onCb={function() {
              dialog.remove()
              params.viewController.handleRefresh()
            }}
          />
        )
      },
      components: {
        updateOldToNewProduct
      },
      props: {
        title: '批量升级产品版本',
        width: '22%',
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false
      }
    })
  }
}
